import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { DEFAULT_LANGUAGE, normalizeLanguage } from './languages';

// Локализации: ключ ресурса — код BCP-47, он же язык для Intl.PluralRules
import enGB from './locales/en-GB.json';
import enUS from './locales/en-US.json';
import ruRU from './locales/ru-RU.json';
import esES from './locales/es-ES.json';
import deDE from './locales/de-DE.json';
import frFR from './locales/fr-FR.json';
import plPL from './locales/pl-PL.json';
import zhCN from './locales/zh-CN.json';
import itIT from './locales/it-IT.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            'en-GB': { translation: enGB },
            'en-US': { translation: enUS },
            'ru-RU': { translation: ruRU },
            'es-ES': { translation: esES },
            'de-DE': { translation: deDE },
            'fr-FR': { translation: frFR },
            'pl-PL': { translation: plPL },
            'zh-CN': { translation: zhCN },
            'it-IT': { translation: itIT },
        },
        // Языка здесь нет намеренно: заданный `lng` выключает детектор, и выбранный
        // в прошлый раз язык перестал бы читаться.
        fallbackLng: DEFAULT_LANGUAGE,
        detection: {
            // Только сохранённый выбор. Язык браузера не спрашиваем: первый визит
            // начинается с DEFAULT_LANGUAGE, как было и до появления детектора.
            order: ['localStorage'],
            caches: ['localStorage'],
            // Единственная точка, где значение из хранилища встречается с приложением:
            // мусор и удалённые языки превращаются в рабочий язык по умолчанию.
            convertDetectedLanguage: normalizeLanguage,
        },
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
